module.exports = __webpack_public_path__ + "static/bg-min-f0ad40250d27e198078a03c04a8d11af.jpg";